'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSlugs = exports.fetchPosts = exports.deletePost = exports.fetchCategories = exports.createCategory = exports.savePost = exports.updatePost = exports.fetchPost = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _callApi = require('./callApi');

var _callApi2 = _interopRequireDefault(_callApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export const fetchPosts = () => callApi('GET', '/posts', null, 'application/json');
var fetchPost = exports.fetchPost = function fetchPost(id) {
  return (0, _callApi2.default)('GET', '/post/' + id, null, 'application/json');
};
var updatePost = exports.updatePost = function updatePost(post) {
  return (0, _callApi2.default)('PUT', '/post/' + post._id, post, 'application/json');
};
var savePost = exports.savePost = function savePost(post) {
  return (0, _callApi2.default)('POST', '/post', post, 'application/json');
};
var createCategory = exports.createCategory = function createCategory(category) {
  return (0, _callApi2.default)('POST', '/category', category, 'application/json');
};
var fetchCategories = exports.fetchCategories = function fetchCategories(f) {
  return (0, _callApi2.default)('GET', '/categories', null, 'application/json');
};
var deletePost = exports.deletePost = function deletePost(id) {
  return (0, _callApi2.default)('POST', '/post/delete/' + id, {}, 'application/json');
};

var fetchPosts = exports.fetchPosts = function fetchPosts(options) {
  return (0, _callApi2.default)('POST', '/post/find', _extends({}, options), 'application/json');
};
var fetchSlugs = exports.fetchSlugs = function fetchSlugs(options) {
  return (0, _callApi2.default)('POST', '/slug/find', _extends({}, options), 'application/json');
};


//////////////////
// WEBPACK FOOTER
// ./~/@hailtrace/client-api/dist/legacy/posts.js
// module id = 740
// module chunks = 0